import { NextPage } from 'next'
import Layout from '@layouts/Text'
import { TextBlock } from '@components/content'
import PageHeader from '@components/PageHeader'
import Link from '@components/Link'
import { H5 } from '@components/Heading'

const BackEndDeveloper: NextPage = () => (
  <>
    <PageHeader title={[['Back-end', 'Developer']]} />

    <Layout>
      <TextBlock className="mb-80">
        <p>
          W związku z rozwojem naszej firmy, szukamy ambitnego i zdolnego
          Back-end developera, chcącego zasilić szeregi naszego zespołu.
        </p>

        <H5>Obowiązki:</H5>

        <ul>
          <li>samodzielne wdrażanie dedykowanych aplikacji webowych</li>
          <li>wdrożenia systemów CMS</li>
          <li>pomaganie kolegom z zespołu</li>
          <li>tworzenie pluginów, komponentów, integratorów itp.</li>
        </ul>

        <H5>Wymagania:</H5>

        <ul>
          <li>dobra znajomość PHP (OOP)</li>
          <li>oczekujemy dobrego jakościowo kodu (SOLID, DRY)</li>
          <li>dobra znajomość relacyjnych baz danych</li>
          <li>
            umiejętność czytania dokumentacji technicznych w j. Angielskim
          </li>
          <li>dobra znajomość Git</li>
          <li>analityczne myślenie oraz chęć nauki</li>
          <li>umiejętność rozwiązywania problemów</li>
        </ul>

        <H5>Mile widziane:</H5>

        <ul>
          <li>znajomość Symfony</li>
          <li>znajomość CMSów Wordpress/Joomla/Drupal/Prestashop</li>
          <li>podstawowa znajomość środowiska Linux</li>
          <li>
            umiejętność posługiwania się narzędziami typu: Grunt, Gulp, Docker,
            Ionic
          </li>
          <li>umiejętność werbalnej komunikacji z ludźmi ;)</li>
        </ul>

        <H5>Oferujemy:</H5>

        <ul>
          <li>
            Wynagrodzenie 6000-10000 zł brutto (w zależności od umiejętności)
          </li>
          <li>pracę w pełnym wymiarze godzin</li>
          <li>budżet szkoleniowy</li>
          <li>
            przyjazną, niekorporacyjną atmosferę w młodym, energicznym zespole
          </li>
          <li>możliwość rozwoju przy ambitnych projektach</li>
          <li>własne stanowisko pracy</li>
          <li>elastyczne godziny pracy</li>
          <li>pakiet multisport i pakiet medyczny</li>
          <li>
            stół z piłkarzykami oraz konsola Xbox One na wyposażeniu biura ;)
          </li>
        </ul>

        <H5>Jak działamy?</H5>

        <ul>
          <li>Scrum / Kanban</li>
          <li>Pair programming</li>
          <li>Code Review</li>
          <li>testy jednostkowe (jak jest czas ;)</li>
          <li>lubimy się uczyć i testować nieszablonowe rozwiązania</li>
          <li>nie zamykamy się na technologie</li>
          <li>szkolimy się</li>
          <li>mamy testera manualnego w zespole</li>
          <li>atomizujemy wszystko :)</li>
          <li>dajemy swobodę w wyborze technologii i narzędzi</li>
        </ul>

        <H5>Stack technologiczny / narzędzia:</H5>

        <ul>
          <li>PHP</li>
          <li>PHP7</li>
          <li>OOP</li>
          <li>SYMFONY</li>
          <li>COMPOSER</li>
          <li>DOCKER</li>
          <li>KUBERNETES</li>
          <li>UNIT TESTS</li>
          <li>CQRS</li>
          <li>MySQL</li>
          <li>GIT</li>
          <li>GITLAB</li>
          <li>RABBIT MQ</li>
          <li>REDIS</li>
          <li>SCRUM</li>
          <li>KANBAN</li>
          <li>JIRA</li>
          <li>PAIR PROGRAMMING</li>
        </ul>
      </TextBlock>

      <TextBlock>
        <p>
          Prosimy o zamieszczenie następującej klauzuli w Państwa dokumentach:
        </p>
        <p>
          <em>
            Niniejszym wyrażam zgodę na przetwarzanie moich danych osobowych
            zawartych w dokumentach rekrutacyjnych dla celów naboru (zgodnie z
            ustawą o ochronie danych osobowych z 29 sierpnia 1997 r., Dz. U. nr
            133, poz. 883).
          </em>
        </p>

        <p>
          CV prosimy wysyłać na{' '}
          <Link href="mailto:hello@empressia.co">hello@empressia.co</Link>
        </p>
      </TextBlock>
    </Layout>
  </>
)

export default BackEndDeveloper
